import type { PokemonV2 } from '../../types/pokemon';
import type { Move } from '../../move/move';
import { getPokemonMovesByUsage } from '../move-access';

export function toOffence(p: PokemonV2): PokemonV2 {
  const ret = {
    ...p,
    selected_ability: p.ability_list ? p.ability_list[0] : undefined,
    selected_move: p.move_list ? p.move_list[0] : undefined,
    effective_slider_step: {
      hp: 0,
      // 攻撃側の初期値は攻撃/特攻を最大想定に寄せる
      attack: 32,
      defense: 0,
      special_attack: 32,
      special_defense: 0,
      speed: 0,
    },
    effective_value: {
      hp: 0,
      attack: 0,
      defense: 0,
      special_attack: 0,
      special_defense: 0,
      speed: 0,
    },
    personality: {
      attack: 1.0,
      defense: 1.0,
      special_attack: 1.0,
      special_defense: 1.0,
      speed: 1.0,
    },
    rankCorrection: {
      attack: 0,
      defense: 0,
      special_attack: 0,
      special_defense: 0,
      speed: 0,
    },
    other_setting: {},
    individualValue: {
      hp: 31,
      attack: 31,
      defense: 31,
      special_attack: 31,
      special_defense: 31,
      speed: 31,
    },
  } as PokemonV2;
  ret.selected_ability_id = ret.selected_ability?.id;
  ret.selected_move_id = ret.selected_move?.id;
  return ret;
}

export function toDefence(p: PokemonV2): PokemonV2 {
  // 変化技も含む全技リストを取得
  const allMoveList = getPokemonMovesByUsage(p, { includeStatus: true });

  // 使用率上位4技を自動選択（変化技含む）
  const selectedMoves = allMoveList && p.often_used_move
    ? p.often_used_move
        .slice(0, 4)
        .map((moveId) => allMoveList.find((move) => move.id === moveId))
        .filter((move): move is Move => move !== undefined)
    : [];

  const selectedMoveIds = selectedMoves.map((move) => move.id);

  const ret = {
    ...p,
    selected_ability: p.ability_list ? p.ability_list[0] : undefined,
    selected_moves: selectedMoves,
    selected_move_ids: selectedMoveIds,
    effective_slider_step: {
      hp: 0,
      attack: 0,
      defense: 0,
      special_attack: 0,
      special_defense: 0,
      speed: 0,
    },
    effective_value: {
      hp: 0,
      attack: 0,
      defense: 0,
      special_attack: 0,
      special_defense: 0,
      speed: 0,
    },
    personality: {
      attack: 1.0,
      defense: 1.0,
      special_attack: 1.0,
      special_defense: 1.0,
      speed: 1.0,
    },
    rankCorrection: {
      attack: 0,
      defense: 0,
      special_attack: 0,
      special_defense: 0,
      speed: 0,
    },
    individualValue: {
      hp: 31,
      attack: 31,
      defense: 31,
      special_attack: 31,
      special_defense: 31,
      speed: 31,
    },
    other_setting: {},
  } as PokemonV2;
  return ret;
}
